export const windowsReload = () => {
  if (typeof window !== 'undefined' && window.location) {
    window.location.reload();
  }
};
